import { getEnvironment } from '@minecraft.environment';
import { useFrontChatWidget } from './Front/useFrontChatWidget';

export const useChatSupportWidget = () => {
  const env = getEnvironment();
  const chatId = env['FRONT_CHAT_ID'];

  // setting shouldHide to true to prevent unwanted initialization of the widgets, the actual show/hide will be handled by the returned functions
  const { show: showFront, hide: hideFront } = useFrontChatWidget({
    chatId,
    shouldHide: true,
  });
  return {
    show: showFront,
    hide: hideFront,
  };
};
